/*
 * Edge Landing Universities JavaScript
 * Migrated from no-vue/src/landing-universities.js to Vite + Tailwind 4 setup
 */

import './landing-universities.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';

// Import landing page-specific modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';
import '../shared/landing/components.js';
import '../shared/landing/pricing-graph.js';

// Landing Universities specific functionality
// Most functionality is handled by imported modules:
// - hero.js: Smooth scroll for CTA buttons
// - animations.js: Fade-in on scroll with [data-fade-in]
// - components.js: Accordions, tabs, tooltips
// - pricing-graph.js: Interactive pricing graph

class LandingUniversities {
  constructor() {
    this.init();
  }

  init() {
    // Page-specific initialization can go here
    // Most landing page features are auto-initialized by the imported modules
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LandingUniversities();
  console.log('Landing: Universities page loaded (Edge/Vite bundle)');
});
